import React from 'react';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { UseFormReturn, useForm } from 'react-hook-form';

import { Form } from '@/uiKit/atoms/Form';
import {
  PatientCreationInfo,
  patientCreationInfoSchema,
} from '@/uiKit/organisms/PatientCreationAndRenewal/PatientInfo/PatientCreationInfo.ts';

export const PATIENT_INFO_FORM_ID = '"patient-creation-info-form"';
export type PatientInfoFormProps = {
  patientInfo: Partial<PatientCreationInfo>;
  onSubmit: (patientInfo: PatientCreationInfo) => void;
  className?: string;
  children?:
    | React.ReactNode
    | ((formContext: UseFormReturn<PatientCreationInfo>) => React.ReactNode);
};

export const PatientInfoForm: React.FC<PatientInfoFormProps> = ({
  patientInfo,
  onSubmit,
  children,
  className,
}) => {
  const form = useForm<PatientCreationInfo>({
    resolver: standardSchemaResolver(patientCreationInfoSchema),
    defaultValues: patientInfo,
  });

  return (
    <Form
      id={PATIENT_INFO_FORM_ID}
      formContext={form}
      onSubmit={onSubmit}
      className={className}
    >
      {typeof children === 'function' ? children(form) : children}
    </Form>
  );
};
